/**
 * Session handshake — exchanges the dashboard auth token (`x-auth-token`,
 * already attached by the client from the request context) for a `sessionInfo`
 * handle that must be sent as `x-session-info` on every subsequent call.
 */
import { endpoints } from '@/config/env';
import { request } from './client';

/**
 * The client unwraps a `{ success, data }` envelope, so the payload we receive
 * is either `{ sessionInfo }` (enveloped) or `{ data: { sessionInfo } }` (raw).
 * Cover both.
 */
interface SessionResponse {
  sessionInfo?: string;
  data?: { sessionInfo?: string };
}

/** POST the session endpoint and return the `sessionInfo` handle (empty if none). */
export async function fetchSessionInfo(signal?: AbortSignal): Promise<string> {
  const response = await request<SessionResponse>(endpoints.session(), { method: 'POST', signal });
  return response?.data?.sessionInfo ?? response?.sessionInfo ?? '';
}
